/* eslint-disable no-unused-vars */
import React from "react";
import axios from "axios";
import { toast } from "sonner";
import { Plus, Trash2, Home, Eye, EyeOff, RefreshCw, LogOut, Edit2, Save, X, Upload, Download, Volume2, Sparkles, Hash, Trophy, FileDown, FileUp } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Card } from "@/components/ui/card";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "@/components/ui/dialog";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger } from "@/components/ui/alert-dialog";
import { API, BACKEND_URL, resolveUrl, useAdmin } from "./adminShared";

export const CountriesTab = () => {
  const {
    countries, setCountries, votes, setVotes, events, setEvents,
    activeEvent, setActiveEvent, showCreateEvent, setShowCreateEvent, newEventName, setNewEventName,
    copyFromEventId, setCopyFromEventId, creatingEvent, setCreatingEvent, showRenameEvent, setShowRenameEvent,
    renameEventName, setRenameEventName, importFile, setImportFile, showImportConfirm, setShowImportConfirm,
    importing, setImporting, newCountry, setNewCountry, editingCountry, setEditingCountry,
    backgroundVideo, setBackgroundVideo, fontTitle, setFontTitle, fontSubtitle, setFontSubtitle,
    fontCountry, setFontCountry, fontPoints, setFontPoints, fontVoting, setFontVoting,
    customFontTitleUrl, setCustomFontTitleUrl, customFontTitleName, setCustomFontTitleName, customFontSubtitleUrl, setCustomFontSubtitleUrl,
    customFontSubtitleName, setCustomFontSubtitleName, customFontCountryUrl, setCustomFontCountryUrl, customFontCountryName, setCustomFontCountryName,
    customFontPointsUrl, setCustomFontPointsUrl, customFontPointsName, setCustomFontPointsName, customFontVotingUrl, setCustomFontVotingUrl,
    customFontVotingName, setCustomFontVotingName, fontSizeTitle, setFontSizeTitle, fontSizeSubtitle, setFontSizeSubtitle,
    fontSizeCountry, setFontSizeCountry, fontSizePoints, setFontSizePoints, fontSizeVoting, setFontSizeVoting,
    primaryColor, setPrimaryColor, secondaryColor, setSecondaryColor, tertiaryColor, setTertiaryColor,
    rowBgEven, setRowBgEven, rowBgOdd, setRowBgOdd, logoUrl, setLogoUrl,
    logoPosition, setLogoPosition, logoSize, setLogoSize, logoZIndex, setLogoZIndex,
    logoOpacity, setLogoOpacity, extraImage1Url, setExtraImage1Url, extraImage1Position, setExtraImage1Position,
    extraImage1Size, setExtraImage1Size, extraImage1ZIndex, setExtraImage1ZIndex, extraImage1Opacity, setExtraImage1Opacity,
    extraImage2Url, setExtraImage2Url, extraImage2Position, setExtraImage2Position, extraImage2Size, setExtraImage2Size,
    extraImage2ZIndex, setExtraImage2ZIndex, extraImage2Opacity, setExtraImage2Opacity, extraImage3Url, setExtraImage3Url,
    extraImage3Position, setExtraImage3Position, extraImage3Size, setExtraImage3Size, extraImage3ZIndex, setExtraImage3ZIndex,
    extraImage3Opacity, setExtraImage3Opacity, defaultArtistPhoto, setDefaultArtistPhoto, artistPhotoSizeMode, setArtistPhotoSizeMode,
    artistPhotoSizePx, setArtistPhotoSizePx, textTitle, setTextTitle, textSubtitle, setTextSubtitle,
    textVotingNow, setTextVotingNow, textWaiting, setTextWaiting, sound12PointsUrl, setSound12PointsUrl,
    confettiEnabled, setConfettiEnabled, confettiColors, setConfettiColors, top1Color, setTop1Color,
    top2Color, setTop2Color, top3Color, setTop3Color, lastPlaceColor, setLastPlaceColor,
    top1Translucent, setTop1Translucent, top2Translucent, setTop2Translucent, top3Translucent, setTop3Translucent,
    lastPlaceTranslucent, setLastPlaceTranslucent, votingColumnCenter, setVotingColumnCenter, leftColSpan, setLeftColSpan,
    rightColSpan, setRightColSpan, votingColSpan, setVotingColSpan, columnGap, setColumnGap,
    subtitleCounterEnabled, setSubtitleCounterEnabled, subtitlePhaseOrder, setSubtitlePhaseOrder, subtitleJuryLabel, setSubtitleJuryLabel,
    subtitleTelevoteLabel, setSubtitleTelevoteLabel, mystery12Text, setMystery12Text, voteDisplayColumns, setVoteDisplayColumns,
    showVoterBorder, setShowVoterBorder, showJuryBadge, setShowJuryBadge, fontVotingSecondary, setFontVotingSecondary,
    customFontVotingSecondaryUrl, setCustomFontVotingSecondaryUrl, customFontVotingSecondaryName, setCustomFontVotingSecondaryName, overlay12Enabled, setOverlay12Enabled,
    overlay12DurationMode, setOverlay12DurationMode, overlay12DurationSeconds, setOverlay12DurationSeconds, overlay12BgStyle, setOverlay12BgStyle,
    overlay12BgColor, setOverlay12BgColor, overlay12BgOpacity, setOverlay12BgOpacity, overlay12TextReceives, setOverlay12TextReceives,
    overlay12UseAdminColors, setOverlay12UseAdminColors, overlay12Visible, setOverlay12Visible, previewGiverId, setPreviewGiverId,
    previewRecipientId, setPreviewRecipientId, winnerOverlayEnabled, setWinnerOverlayEnabled, winnerOverlayDurationMode, setWinnerOverlayDurationMode,
    winnerOverlayDurationSeconds, setWinnerOverlayDurationSeconds, winnerOverlayBgStyle, setWinnerOverlayBgStyle, winnerOverlayBgColor, setWinnerOverlayBgColor,
    winnerOverlayBgOpacity, setWinnerOverlayBgOpacity, winnerOverlayTitleText, setWinnerOverlayTitleText, winnerOverlaySubtitleText, setWinnerOverlaySubtitleText,
    winnerOverlayUseAdminColors, setWinnerOverlayUseAdminColors, winnerOverlayShowConfetti, setWinnerOverlayShowConfetti, winnerOverlayShowPoints, setWinnerOverlayShowPoints,
    winnerOverlayVisible, setWinnerOverlayVisible, overlay12StyleCustom, setOverlay12StyleCustom, overlay12FontTitle, setOverlay12FontTitle,
    overlay12FontCountry, setOverlay12FontCountry, overlay12FontSecondary, setOverlay12FontSecondary, overlay12SizeScale, setOverlay12SizeScale,
    winnerOverlayStyleCustom, setWinnerOverlayStyleCustom, winnerOverlayFontTitle, setWinnerOverlayFontTitle, winnerOverlayFontCountry, setWinnerOverlayFontCountry,
    winnerOverlayFontSecondary, setWinnerOverlayFontSecondary, winnerOverlaySizeScale, setWinnerOverlaySizeScale, loading, setLoading,
    exportingPdf, setExportingPdf, winnerPreviewId, setWinnerPreviewId, adminInitRef, adminPollRef,
    navigate, fetchCurrentVoterStatus, handleHideOverlay12, handlePreviewOverlay12, handleShowWinner, handleHideWinner,
    getFontFormat, fetchBackground, handleSetBackground, handleExportPdf, handleFileUpload, fetchCountries,
    fetchVotes, downloadFromApi, handleExportVotesPdf, handleExportVotesExcel, fetchEvents, reloadEventData,
    handleSelectEvent, handleCreateEvent, handleRenameEvent, handleExportEvent, handleImportEvent, handleAddCountry,
    handleDeleteCountry, handleSetCurrentVoter, handleResetVotes, handleLogout, handleApplyVotes, handleReveal12Points,
    handleEditCountry, handleUpdateCountry, handleToggleBadge, handleToggleTranslucent, handleResetAllBarColors, votingCountries, juryMembers,
    votedCountries,
  } = useAdmin();
  return (
          <TabsContent value="countries" className="space-y-6 mt-6">
            <Card className="bg-zinc-900/80 border-zinc-800 p-6">
              <h2 className="font-unbounded text-xl text-white mb-4">Agregar País / Jurado</h2>
              <form onSubmit={handleAddCountry} className="space-y-4">
                <div className="grid md:grid-cols-2 gap-4">
                  <div>
                    <Label htmlFor="name" className="text-zinc-300">Nombre</Label>
                    <Input
                      id="name"
                      data-testid="input-country-name"
                      value={newCountry.name}
                      onChange={(e) => setNewCountry({...newCountry, name: e.target.value})}
                      className="bg-zinc-800 border-zinc-700 text-white"
                      placeholder="España, Francia, etc."
                    />
                  </div>
                  <div>
                    <Label htmlFor="password" className="text-zinc-300">Contraseña</Label>
                    <Input
                      id="password"
                      data-testid="input-country-password"
                      type="text"
                      value={newCountry.password}
                      onChange={(e) => setNewCountry({...newCountry, password: e.target.value})}
                      className="bg-zinc-800 border-zinc-700 text-white"
                      placeholder="Contraseña secreta"
                    />
                  </div>
                  <div>
                    <Label htmlFor="running-order" className="text-zinc-300">Orden de actuación</Label>
                    <Input
                      id="running-order"
                      data-testid="input-country-running-order"
                      type="number"
                      min="0"
                      value={newCountry.running_order ?? 0}
                      onChange={(e) => setNewCountry({...newCountry, running_order: e.target.value})}
                      className="bg-zinc-800 border-zinc-700 text-white"
                      placeholder="1, 2, 3..."
                    />
                  </div>
                </div>
                <div className="grid md:grid-cols-2 gap-4">
                  <div>
                    <Label htmlFor="flag" className="text-zinc-300 mb-2 block">Bandera</Label>
                    <Input
                      id="flag"
                      data-testid="input-flag-url"
                      value={newCountry.flag_url}
                      onChange={(e) => setNewCountry({...newCountry, flag_url: e.target.value})}
                      className="bg-zinc-800 border-zinc-700 text-white mb-2"
                      placeholder="URL o sube archivo"
                    />
                    <div className="flex gap-2">
                      <input
                        type="file"
                        id="flag-file"
                        accept="image/*"
                        className="hidden"
                        onChange={async (e) => {
                          const file = e.target.files[0];
                          if (file) {
                            const url = await handleFileUpload(file, 'temp');
                            if (url) setNewCountry({...newCountry, flag_url: url});
                          }
                        }}
                      />
                      <Button
                        type="button"
                        onClick={() => document.getElementById('flag-file').click()}
                        variant="outline"
                        className="flex-1 bg-zinc-800 border-zinc-700 text-white hover:bg-zinc-700"
                      >
                        <Upload className="w-4 h-4 mr-2" />
                        Subir Archivo
                      </Button>
                    </div>
                  </div>
                  <div>
                    <Label htmlFor="artist" className="text-zinc-300 mb-2 block">Foto/Vídeo Votante</Label>
                    <Input
                      id="artist"
                      data-testid="input-artist-url"
                      value={newCountry.artist_photo_url}
                      onChange={(e) => setNewCountry({...newCountry, artist_photo_url: e.target.value})}
                      className="bg-zinc-800 border-zinc-700 text-white mb-2"
                      placeholder="URL o sube imagen/vídeo"
                    />
                    <div className="flex gap-2">
                      <input
                        type="file"
                        id="artist-file"
                        accept="image/*,video/*"
                        className="hidden"
                        onChange={async (e) => {
                          const file = e.target.files[0];
                          if (file) {
                            const url = await handleFileUpload(file, 'temp');
                            if (url) setNewCountry({...newCountry, artist_photo_url: url});
                          }
                        }}
                      />
                      <Button
                        type="button"
                        onClick={() => document.getElementById('artist-file').click()}
                        variant="outline"
                        className="flex-1 bg-zinc-800 border-zinc-700 text-white hover:bg-zinc-700"
                      >
                        <Upload className="w-4 h-4 mr-2" />
                        Subir Archivo
                      </Button>
                    </div>
                  </div>
                </div>
                <div className="grid md:grid-cols-3 gap-4">
                  <div>
                    <Label htmlFor="overlay-photo" className="text-zinc-300 mb-2 block">Foto Artista (PNG para overlays)</Label>
                    <Input
                      id="overlay-photo"
                      data-testid="input-overlay-photo-url"
                      value={newCountry.overlay_photo_url}
                      onChange={(e) => setNewCountry({...newCountry, overlay_photo_url: e.target.value})}
                      className="bg-zinc-800 border-zinc-700 text-white mb-2"
                      placeholder="URL o sube el PNG"
                    />
                    <div className="flex gap-2">
                      <input
                        type="file"
                        id="overlay-photo-file"
                        accept="image/*"
                        className="hidden"
                        onChange={async (e) => {
                          const file = e.target.files[0];
                          if (file) {
                            const url = await handleFileUpload(file, 'temp');
                            if (url) setNewCountry({...newCountry, overlay_photo_url: url});
                          }
                        }}
                      />
                      <Button
                        type="button"
                        onClick={() => document.getElementById('overlay-photo-file').click()}
                        variant="outline"
                        className="flex-1 bg-zinc-800 border-zinc-700 text-white hover:bg-zinc-700"
                      >
                        <Upload className="w-4 h-4 mr-2" />
                        Subir PNG
                      </Button>
                    </div>
                  </div>
                  <div>
                    <Label htmlFor="artist-name" className="text-zinc-300 mb-2 block">Nombre del artista</Label>
                    <Input
                      id="artist-name"
                      data-testid="input-artist-name"
                      value={newCountry.artist_name}
                      onChange={(e) => setNewCountry({...newCountry, artist_name: e.target.value})}
                      className="bg-zinc-800 border-zinc-700 text-white"
                      placeholder="Ej: Charlotte MacInnes"
                    />
                  </div>
                  <div>
                    <Label htmlFor="song-title" className="text-zinc-300 mb-2 block">Canción</Label>
                    <Input
                      id="song-title"
                      data-testid="input-song-title"
                      value={newCountry.song_title}
                      onChange={(e) => setNewCountry({...newCountry, song_title: e.target.value})}
                      className="bg-zinc-800 border-zinc-700 text-white"
                      placeholder="Ej: Struck"
                    />
                  </div>
                </div>
                <div className="flex items-center gap-2">
                  <input
                    type="checkbox"
                    id="is_jury"
                    data-testid="checkbox-is-jury"
                    checked={newCountry.is_jury}
                    onChange={(e) => setNewCountry({...newCountry, is_jury: e.target.checked})}
                    className="w-4 h-4"
                  />
                  <Label htmlFor="is_jury" className="text-zinc-300 cursor-pointer">Es miembro del jurado (puede votar pero no recibe votos)</Label>
                </div>
                <Button 
                  data-testid="btn-add-country"
                  type="submit" 
                  disabled={loading}
                  className="w-full bg-pink-600 hover:bg-pink-500 text-white font-unbounded"
                >
                  <Plus className="w-4 h-4 mr-2" />
                  {loading ? "Agregando..." : "Agregar"}
                </Button>
              </form>
            </Card>

            <div className="space-y-4">
              <div className="flex items-center justify-between">
                <h2 className="font-unbounded text-xl text-white">Países Participantes ({votingCountries.length})</h2>
                <AlertDialog>
                  <AlertDialogTrigger asChild>
                    <Button
                      data-testid="btn-reset-all-bar-colors"
                      variant="outline"
                      size="sm"
                      className="bg-zinc-800 border-zinc-700 text-zinc-300 hover:bg-zinc-700 hover:text-white"
                    >
                      <RefreshCw className="w-4 h-4 mr-2" />
                      Restablecer colores de barras
                    </Button>
                  </AlertDialogTrigger>
                  <AlertDialogContent className="bg-zinc-900 border-zinc-800">
                    <AlertDialogHeader>
                      <AlertDialogTitle className="text-white">¿Restablecer todos los colores de barras?</AlertDialogTitle>
                      <AlertDialogDescription className="text-zinc-400">
                        Se eliminará el color personalizado de TODAS las barras de esta edición. Las barras volverán a usar los colores del Top 3 y el color por defecto. Esto no afecta a los votos ni a la configuración.
                      </AlertDialogDescription>
                    </AlertDialogHeader>
                    <AlertDialogFooter>
                      <AlertDialogCancel className="bg-zinc-800 border-zinc-700 text-white hover:bg-zinc-700">Cancelar</AlertDialogCancel>
                      <AlertDialogAction
                        data-testid="btn-confirm-reset-all-bar-colors"
                        onClick={handleResetAllBarColors}
                        className="bg-pink-600 hover:bg-pink-500 text-white"
                      >
                        Restablecer
                      </AlertDialogAction>
                    </AlertDialogFooter>
                  </AlertDialogContent>
                </AlertDialog>
              </div>
              <div className="grid md:grid-cols-2 gap-4">
                {votingCountries.map(country => (
                  <Card key={country.id} className="bg-zinc-900/80 border-zinc-800 p-4">
                    {editingCountry?.id === country.id ? (
                      <div className="space-y-3">
                        <Input
                          value={editingCountry.name}
                          onChange={(e) => setEditingCountry({...editingCountry, name: e.target.value})}
                          className="bg-zinc-800 border-zinc-700 text-white"
                          placeholder="Nombre"
                        />
                        <Input
                          value={editingCountry.password}
                          onChange={(e) => setEditingCountry({...editingCountry, password: e.target.value})}
                          className="bg-zinc-800 border-zinc-700 text-white"
                          placeholder="Contraseña"
                        />
                        <div>
                          <label className="text-zinc-400 text-sm">Orden de actuación</label>
                          <Input
                            data-testid={`edit-running-order-${country.id}`}
                            type="number"
                            min="0"
                            value={editingCountry.running_order ?? 0}
                            onChange={(e) => setEditingCountry({...editingCountry, running_order: e.target.value})}
                            className="bg-zinc-800 border-zinc-700 text-white"
                            placeholder="1, 2, 3..."
                          />
                        </div>
                        
                        {/* Flag URL + Upload */}
                        <div className="space-y-2">
                          <label className="text-zinc-400 text-sm">Bandera</label>
                          <div className="flex gap-2">
                            <Input
                              value={editingCountry.flag_url}
                              onChange={(e) => setEditingCountry({...editingCountry, flag_url: e.target.value})}
                              className="bg-zinc-800 border-zinc-700 text-white flex-1"
                              placeholder="URL Bandera"
                            />
                            <input
                              type="file"
                              id={`edit-flag-${country.id}`}
                              accept="image/*"
                              className="hidden"
                              onChange={async (e) => {
                                const file = e.target.files[0];
                                if (file) {
                                  const formData = new FormData();
                                  formData.append('file', file);
                                  try {
                                    const response = await axios.post(`${API}/upload`, formData, {
                                      headers: { 'Content-Type': 'multipart/form-data' }
                                    });
                                    const uploadedUrl = `${BACKEND_URL}${response.data.url}`;
                                    setEditingCountry(prev => ({...prev, flag_url: uploadedUrl}));
                                    toast.success("Bandera subida");
                                  } catch (error) {
                                    toast.error("Error al subir archivo");
                                  }
                                }
                              }}
                            />
                            <Button
                              type="button"
                              onClick={() => document.getElementById(`edit-flag-${country.id}`).click()}
                              variant="outline"
                              size="icon"
                              className="bg-zinc-800 border-zinc-700 hover:bg-zinc-700"
                            >
                              <Upload className="w-4 h-4" />
                            </Button>
                          </div>
                          {editingCountry.flag_url && (
                            <img src={resolveUrl(editingCountry.flag_url)} alt="Preview" className="w-16 h-10 object-contain rounded border border-zinc-700" />
                          )}
                        </div>
                        
                        {/* Artist Photo/Video URL + Upload */}
                        <div className="space-y-2">
                          <label className="text-zinc-400 text-sm">Foto/Vídeo Votante</label>
                          <div className="flex gap-2">
                            <Input
                              value={editingCountry.artist_photo_url}
                              onChange={(e) => setEditingCountry({...editingCountry, artist_photo_url: e.target.value})}
                              className="bg-zinc-800 border-zinc-700 text-white flex-1"
                              placeholder="URL Foto o Vídeo del Artista"
                            />
                            <input
                              type="file"
                              id={`edit-artist-${country.id}`}
                              accept="image/*,video/*"
                              className="hidden"
                              onChange={async (e) => {
                                const file = e.target.files[0];
                                if (file) {
                                  const formData = new FormData();
                                  formData.append('file', file);
                                  try {
                                    const response = await axios.post(`${API}/upload`, formData, {
                                      headers: { 'Content-Type': 'multipart/form-data' }
                                    });
                                    const uploadedUrl = `${BACKEND_URL}${response.data.url}`;
                                    setEditingCountry(prev => ({...prev, artist_photo_url: uploadedUrl}));
                                    toast.success("Archivo subido");
                                  } catch (error) {
                                    toast.error("Error al subir archivo");
                                  }
                                }
                              }}
                            />
                            <Button
                              type="button"
                              onClick={() => document.getElementById(`edit-artist-${country.id}`).click()}
                              variant="outline"
                              size="icon"
                              className="bg-zinc-800 border-zinc-700 hover:bg-zinc-700"
                            >
                              <Upload className="w-4 h-4" />
                            </Button>
                          </div>
                          {editingCountry.artist_photo_url && (
                            /\.(mp4|webm|mov|avi|ogg)$/i.test(editingCountry.artist_photo_url) ? (
                              <video src={editingCountry.artist_photo_url} className="w-16 h-16 object-cover rounded border border-zinc-700" muted autoPlay loop />
                            ) : (
                              <img src={editingCountry.artist_photo_url} alt="Preview" className="w-16 h-16 object-cover rounded border border-zinc-700" />
                            )
                          )}
                        </div>
                        
                        {/* Overlay PNG + artist + song */}
                        <div className="space-y-2">
                          <label className="text-zinc-400 text-sm">Foto Artista (PNG para overlays)</label>
                          <div className="flex gap-2">
                            <Input
                              value={editingCountry.overlay_photo_url || ""}
                              onChange={(e) => setEditingCountry({...editingCountry, overlay_photo_url: e.target.value})}
                              className="bg-zinc-800 border-zinc-700 text-white flex-1"
                              placeholder="URL del PNG circular del artista"
                              data-testid={`edit-overlay-photo-${country.id}`}
                            />
                            <input
                              type="file"
                              id={`edit-overlay-photo-${country.id}`}
                              accept="image/*"
                              className="hidden"
                              onChange={async (e) => {
                                const file = e.target.files[0];
                                if (file) {
                                  const formData = new FormData();
                                  formData.append('file', file);
                                  try {
                                    const response = await axios.post(`${API}/upload`, formData, {
                                      headers: { 'Content-Type': 'multipart/form-data' }
                                    });
                                    const uploadedUrl = `${BACKEND_URL}${response.data.url}`;
                                    setEditingCountry(prev => ({...prev, overlay_photo_url: uploadedUrl}));
                                    toast.success("Archivo subido");
                                  } catch (error) {
                                    toast.error("Error al subir archivo");
                                  }
                                }
                              }}
                            />
                            <Button
                              type="button"
                              onClick={() => document.getElementById(`edit-overlay-photo-${country.id}`).click()}
                              variant="outline"
                              size="icon"
                              className="bg-zinc-800 border-zinc-700 hover:bg-zinc-700"
                            >
                              <Upload className="w-4 h-4" />
                            </Button>
                          </div>
                          {editingCountry.overlay_photo_url && (
                            <img src={editingCountry.overlay_photo_url} alt="Preview overlay" className="w-16 h-16 object-contain rounded border border-zinc-700" />
                          )}
                        </div>
                        <div className="grid grid-cols-2 gap-2">
                          <div>
                            <label className="text-zinc-400 text-sm">Nombre del artista</label>
                            <Input
                              value={editingCountry.artist_name || ""}
                              onChange={(e) => setEditingCountry({...editingCountry, artist_name: e.target.value})}
                              className="bg-zinc-800 border-zinc-700 text-white"
                              placeholder="Charlotte MacInnes"
                              data-testid={`edit-artist-name-${country.id}`}
                            />
                          </div>
                          <div>
                            <label className="text-zinc-400 text-sm">Canción</label>
                            <Input
                              value={editingCountry.song_title || ""}
                              onChange={(e) => setEditingCountry({...editingCountry, song_title: e.target.value})}
                              className="bg-zinc-800 border-zinc-700 text-white"
                              placeholder="Struck"
                              data-testid={`edit-song-title-${country.id}`}
                            />
                          </div>
                        </div>
                        
                        <div className="flex gap-2">
                          <Button
                            onClick={handleUpdateCountry}
                            disabled={loading}
                            className="flex-1 bg-green-600 hover:bg-green-500"
                          >
                            <Save className="w-4 h-4 mr-2" />
                            Guardar
                          </Button>
                          <Button
                            onClick={() => setEditingCountry(null)}
                            variant="ghost"
                            className="flex-1"
                          >
                            <X className="w-4 h-4 mr-2" />
                            Cancelar
                          </Button>
                        </div>
                      </div>
                    ) : (
                      <div className="space-y-2">
                        <div className="flex items-start gap-4">
                          <img 
                            src={resolveUrl(country.flag_url)} 
                            alt={country.name}
                            className="w-16 h-12 object-contain"
                            onError={(e) => e.target.src = 'https://placehold.co/80x60/000/FFF?text=Flag'}
                          />
                          <div className="flex-1">
                            <h3 className="font-unbounded text-white font-semibold">{country.name}</h3>
                            <p className="text-zinc-500 text-sm">Contraseña: {country.password}</p>
                            <p className="text-zinc-500 text-sm" data-testid={`running-order-${country.id}`}>Orden de actuación: {country.running_order || "—"}</p>
                          </div>
                          <div className="flex gap-1">
                            <Button
                              data-testid={`btn-badge-${country.id}`}
                              onClick={() => handleToggleBadge(country.id)}
                              variant="ghost"
                              size="icon"
                              className={country.show_position_badge !== false
                                ? "text-yellow-400 hover:text-yellow-300 hover:bg-yellow-950/50"
                                : "text-zinc-600 hover:text-zinc-400 hover:bg-zinc-800/50"
                              }
                              title={country.show_position_badge !== false ? "Badge activo" : "Badge desactivado"}
                            >
                              <Hash className="w-4 h-4" />
                            </Button>
                            <Button
                              data-testid={`btn-edit-${country.id}`}
                              onClick={() => handleEditCountry(country)}
                              variant="ghost"
                              size="icon"
                              className="text-blue-400 hover:text-blue-300 hover:bg-blue-950/50"
                            >
                              <Edit2 className="w-4 h-4" />
                            </Button>
                            <Button
                              data-testid={`btn-delete-${country.id}`}
                              onClick={() => handleDeleteCountry(country.id, country.name)}
                              variant="ghost"
                              size="icon"
                              className="text-red-400 hover:text-red-300 hover:bg-red-950/50"
                            >
                              <Trash2 className="w-4 h-4" />
                            </Button>
                          </div>
                        </div>
                        {/* Bar color picker + translucent toggle */}
                        <div className="flex items-center gap-3 pl-1">
                          <div className="flex items-center gap-2">
                            <label className="text-zinc-500 text-xs">Color barra:</label>
                            <input
                              type="color"
                              data-testid={`bar-color-${country.id}`}
                              value={country.bar_color || "#18181b"}
                              onChange={async (e) => {
                                try {
                                  await axios.put(`${API}/admin/countries/${country.id}`, { bar_color: e.target.value });
                                  fetchCountries();
                                } catch (err) { toast.error("Error"); }
                              }}
                              className="w-6 h-6 rounded cursor-pointer border border-zinc-700 p-0"
                            />
                            {country.bar_color && (
                              <button
                                onClick={async () => {
                                  try {
                                    await axios.put(`${API}/admin/countries/${country.id}`, { bar_color: null });
                                    fetchCountries();
                                    toast.success("Color por defecto restaurado");
                                  } catch (err) { toast.error("Error"); }
                                }}
                                className="text-zinc-600 hover:text-zinc-400 text-xs underline"
                              >
                                Reset
                              </button>
                            )}
                          </div>
                          <button
                            data-testid={`btn-translucent-${country.id}`}
                            onClick={() => handleToggleTranslucent(country.id)}
                            className={`text-xs px-2 py-0.5 rounded border ${
                              country.bar_translucent
                                ? 'border-cyan-500/50 text-cyan-400 bg-cyan-950/30'
                                : 'border-zinc-700 text-zinc-500 hover:text-zinc-300'
                            }`}
                            title={country.bar_translucent ? "Barra translúcida" : "Barra opaca"}
                          >
                            {country.bar_translucent ? "Translúcido" : "Opaco"}
                          </button>
                        </div>
                      </div>
                    )}
                  </Card>
                ))}
              </div>
            </div>

            {juryMembers.length > 0 && (
              <div className="space-y-4">
                <h2 className="font-unbounded text-xl text-white">Jurado Profesional ({juryMembers.length})</h2>
                <div className="grid md:grid-cols-2 gap-4">
                  {juryMembers.map(jury => (
                    <Card key={jury.id} className="bg-cyan-900/20 border-cyan-800 p-4">
                      {editingCountry?.id === jury.id ? (
                        <div className="space-y-3">
                          <Input
                            value={editingCountry.name}
                            onChange={(e) => setEditingCountry({...editingCountry, name: e.target.value})}
                            className="bg-zinc-800 border-zinc-700 text-white"
                            placeholder="Nombre"
                          />
                          <Input
                            value={editingCountry.password}
                            onChange={(e) => setEditingCountry({...editingCountry, password: e.target.value})}
                            className="bg-zinc-800 border-zinc-700 text-white"
                            placeholder="Contraseña"
                          />
                          
                          {/* Bandera del Jurado (opcional) */}
                          <div className="space-y-2">
                            <label className="text-zinc-400 text-sm">Bandera (opcional)</label>
                            <div className="flex gap-2">
                              <Input
                                value={editingCountry.flag_url || ""}
                                onChange={(e) => setEditingCountry({...editingCountry, flag_url: e.target.value})}
                                className="bg-zinc-800 border-zinc-700 text-white flex-1"
                                placeholder="URL de la bandera o déjalo vacío"
                              />
                              <input
                                type="file"
                                id={`edit-jury-flag-${jury.id}`}
                                accept="image/*"
                                className="hidden"
                                onChange={async (e) => {
                                  const file = e.target.files[0];
                                  if (file) {
                                    const formData = new FormData();
                                    formData.append('file', file);
                                    try {
                                      const response = await axios.post(`${API}/upload`, formData, {
                                        headers: { 'Content-Type': 'multipart/form-data' }
                                      });
                                      const uploadedUrl = `${BACKEND_URL}${response.data.url}`;
                                      setEditingCountry(prev => ({...prev, flag_url: uploadedUrl}));
                                      toast.success("Bandera subida");
                                    } catch (error) {
                                      toast.error("Error al subir archivo");
                                    }
                                  }
                                }}
                              />
                              <Button
                                type="button"
                                onClick={() => document.getElementById(`edit-jury-flag-${jury.id}`).click()}
                                variant="outline"
                                size="icon"
                                className="bg-zinc-800 border-zinc-700 hover:bg-zinc-700"
                              >
                                <Upload className="w-4 h-4" />
                              </Button>
                              {editingCountry.flag_url && (
                                <Button
                                  type="button"
                                  onClick={() => setEditingCountry({...editingCountry, flag_url: ""})}
                                  variant="outline"
                                  size="icon"
                                  className="bg-red-900/30 border-red-800 hover:bg-red-900/50 text-red-400"
                                  title="Quitar bandera"
                                >
                                  <X className="w-4 h-4" />
                                </Button>
                              )}
                            </div>
                            {editingCountry.flag_url && (
                              <img src={resolveUrl(editingCountry.flag_url)} alt="Preview bandera" className="w-16 h-10 object-contain rounded border border-zinc-700" />
                            )}
                          </div>
                          
                          {/* Texto alternativo (si no hay bandera) */}
                          <div className="space-y-2">
                            <label className="text-zinc-400 text-sm">Texto alternativo (si no hay bandera)</label>
                            <Input
                              value={editingCountry.flag_text || ""}
                              onChange={(e) => setEditingCountry({...editingCountry, flag_text: e.target.value})}
                              className="bg-zinc-800 border-zinc-700 text-white"
                              placeholder="Ej: JURADO, TVE, Organización..."
                            />
                            <p className="text-zinc-600 text-xs">Se mostrará en el Visualizer cuando no haya bandera configurada</p>
                          </div>
                          
                          {/* Foto/Vídeo del Jurado */}
                          <div className="space-y-2">
                            <label className="text-zinc-400 text-sm">Foto/Vídeo del Jurado</label>
                            <div className="flex gap-2">
                              <Input
                                value={editingCountry.artist_photo_url || ""}
                                onChange={(e) => setEditingCountry({...editingCountry, artist_photo_url: e.target.value})}
                                className="bg-zinc-800 border-zinc-700 text-white flex-1"
                                placeholder="URL Foto o Vídeo"
                              />
                              <input
                                type="file"
                                id={`edit-jury-photo-${jury.id}`}
                                accept="image/*,video/*"
                                className="hidden"
                                onChange={async (e) => {
                                  const file = e.target.files[0];
                                  if (file) {
                                    const formData = new FormData();
                                    formData.append('file', file);
                                    try {
                                      const response = await axios.post(`${API}/upload`, formData, {
                                        headers: { 'Content-Type': 'multipart/form-data' }
                                      });
                                      const uploadedUrl = `${BACKEND_URL}${response.data.url}`;
                                      setEditingCountry(prev => ({...prev, artist_photo_url: uploadedUrl}));
                                      toast.success("Archivo subido");
                                    } catch (error) {
                                      toast.error("Error al subir archivo");
                                    }
                                  }
                                }}
                              />
                              <Button
                                type="button"
                                onClick={() => document.getElementById(`edit-jury-photo-${jury.id}`).click()}
                                variant="outline"
                                size="icon"
                                className="bg-zinc-800 border-zinc-700 hover:bg-zinc-700"
                              >
                                <Upload className="w-4 h-4" />
                              </Button>
                            </div>
                            {editingCountry.artist_photo_url && (
                              /\.(mp4|webm|mov|avi|ogg)$/i.test(editingCountry.artist_photo_url) ? (
                                <video src={editingCountry.artist_photo_url} className="w-16 h-16 object-cover rounded border border-zinc-700" muted autoPlay loop />
                              ) : (
                                <img src={editingCountry.artist_photo_url} alt="Preview" className="w-16 h-16 object-cover rounded border border-zinc-700" />
                              )
                            )}
                          </div>
                          
                          <div className="flex gap-2">
                            <Button
                              onClick={handleUpdateCountry}
                              disabled={loading}
                              className="flex-1 bg-green-600 hover:bg-green-500"
                            >
                              <Save className="w-4 h-4 mr-2" />
                              Guardar
                            </Button>
                            <Button
                              onClick={() => setEditingCountry(null)}
                              variant="ghost"
                              className="flex-1"
                            >
                              <X className="w-4 h-4 mr-2" />
                              Cancelar
                            </Button>
                          </div>
                        </div>
                      ) : (
                        <div className="flex items-start gap-4">
                          {jury.artist_photo_url ? (
                            /\.(mp4|webm|mov|avi|ogg)$/i.test(jury.artist_photo_url) ? (
                              <video 
                                src={resolveUrl(jury.artist_photo_url)} 
                                className="w-16 h-16 object-cover rounded border border-cyan-700" 
                                muted 
                                autoPlay 
                                loop 
                              />
                            ) : (
                              <img 
                                src={resolveUrl(jury.artist_photo_url)} 
                                alt={jury.name}
                                className="w-16 h-16 object-cover rounded border border-cyan-700"
                                onError={(e) => e.target.src = 'https://placehold.co/64x64/0e7490/FFF?text=J'}
                              />
                            )
                          ) : (
                            <div className="w-16 h-16 bg-cyan-900/50 rounded flex items-center justify-center border border-cyan-700">
                              <span className="text-cyan-400 font-bold text-xs">JURADO</span>
                            </div>
                          )}
                          <div className="flex-1">
                            <h3 className="font-unbounded text-white font-semibold">{jury.name}</h3>
                            <p className="text-zinc-500 text-sm">Contraseña: {jury.password}</p>
                          </div>
                          <div className="flex gap-1">
                            <Button
                              data-testid={`btn-edit-jury-${jury.id}`}
                              onClick={() => handleEditCountry(jury)}
                              variant="ghost"
                              size="icon"
                              className="text-blue-400 hover:text-blue-300 hover:bg-blue-950/50"
                            >
                              <Edit2 className="w-4 h-4" />
                            </Button>
                            <Button
                              data-testid={`btn-delete-jury-${jury.id}`}
                              onClick={() => handleDeleteCountry(jury.id, jury.name)}
                              variant="ghost"
                              size="icon"
                              className="text-red-400 hover:text-red-300 hover:bg-red-950/50"
                            >
                              <Trash2 className="w-4 h-4" />
                            </Button>
                          </div>
                        </div>
                      )}
                    </Card>
                  ))}
                </div>
              </div>
            )}
          </TabsContent>
  );
};
